import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { FaApple } from 'react-icons/fa';

import { SocialLoginButton } from './SocialLoginButton';

export const AppleLoginButton = ({ beforeProvider, ...rest }) => {
    const { t } = useTranslation('auth');

    return (
        <SocialLoginButton icon={FaApple} as="a" href="/api/auth/login/apple" backgroundColor="#000" {...rest}>
            {t(beforeProvider || 'auth.loginWith', { provider: 'Apple' })}
        </SocialLoginButton>
    );
};

AppleLoginButton.propTypes = {
    beforeProvider: PropTypes.string,
};
